import axios from 'axios';
import { baseUrl, token } from '../../../../services/Apis';

export const ptevaInstrumentosApi = `${baseUrl}/pteva-instrumentos`;

export const allPevaActividadesService = async (params) => {
  const res = await axios.get(ptevaInstrumentosApi, {
    headers: token({}),
    params,
  });
  return res;
};

export const savePevaActividadesService = async (id, data) => {
  let res;
  if (id) {
    res = await axios.patch(`${ptevaInstrumentosApi}/${id}`, data, {
      headers: token({}),
    });
  } else {
    res = await axios.post(ptevaInstrumentosApi, data, {
      headers: token({}),
    });
  }
  return res;
};

export const onePevaActividadesService = async (id) => {
  const res = await axios.get(`${ptevaInstrumentosApi}/${id}`, {
    headers: token({}),
  });
  return res;
};

export const deletePevaActividadesService = async (id) => {
  const res = await axios.delete(`${ptevaInstrumentosApi}/${id}`, {
    headers: token({}),
  });
  return res;
};
